<template>
  <div
    class="w-full text-center text-white p-3 tracking-wider font-semibold bg-gray-900 bottom-0"
  >
    <h1>
      Copyright © 2021 | All Rights Reserved
      <span class="hidden sm:inline">|</span> <br class="block sm:hidden" />
      Developed by
      <router-link
        class="text-md text-green-400 font-light italic underline"
        to="/credits"
        >DSC-VJTI</router-link
      >
    </h1>
  </div>
</template>
